<template>
    <div class="breadcrumb text_13">
        <ul>
            <li>
                <nuxt-link to="/">{{ $t("main") }}</nuxt-link>
            </li>
            <li v-for="(crumb, i) in crumbs" :key="i">
                <div class="like-link" @click="emitPopstate(crumb.url)" :to="crumb.url" v-if="crumb.url">
                    {{ crumb.name }}
                </div>
                <span v-else> {{ crumb.name }}</span>
            </li>
        </ul>
    </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
    name: "BreadcrumbsBlock",
    computed: mapGetters({
        crumbs: "crumbs/get",
        needUpdateCatalog: "catalog/getNeedUpdateCatalog",
    }),

    methods: {
        emitPopstate(newRoute) {
            if (this.needUpdateCatalog) {
                this.$router.push(newRoute);
                this.$nuxt.$emit("update-location-href");
            } else {
                this.$nuxt.$emit("redirect-from-product-modal", newRoute);
            }
        },
    },
};
</script>
<style scoped lang="less">
.breadcrumb {
    flex-grow: 1;
    padding: 9px 0;
    height: 36px;
}

ul {
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    display: flex;
    align-items: center;
    margin: 0;
}

li {
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    display: flex;
    align-items: center;

    &.linked {
        cursor: pointer;

        &:hover {
            color: @accent;
        }
    }

    + li {
        &:before {
            content: "/";

            margin: 0px 12px;
            display: inline-block;
            .is_apple & {
                margin-bottom: 1px;
            }
        }
    }
}
</style>
